import { formatRequest } from "../../utils/function";
import axiosInstance from "../axiosInstance";

export function getAirportsSerachList(data) {
  return axiosInstance.post(`/airports/search`, formatRequest(data));
}

export function createSerachFlightApi(data) {
  return axiosInstance.post(`/search-flights`, formatRequest(data));
}

export function getFlightResultList(data) {
  return axiosInstance.post(`/flights-results`, formatRequest(data));
}

export function getFlightDetailsList(data) {
  return axiosInstance.post(`/flights-details`, formatRequest(data));
}

export function createSaveFlight(data) {
  return axiosInstance.post(`/save-flights/create`, formatRequest(data));
}

export function getSaveFlightsList(data) {
  return axiosInstance.post(`/save-flights/list`, formatRequest(data));
}

export function deleteSaveFlight(data) {
  return axiosInstance.post(`/save-flights/delete`, formatRequest(data));
}





